import { SVGProps } from "react";

const BasketErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 48}
    height={props.height || 48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.3798 12.7599C9.99977 12.7599 9.59977 12.5999 9.31977 12.3199C8.73977 11.7399 8.73977 10.7799 9.31977 10.1999L16.5798 2.93988C17.1598 2.35988 18.1198 2.35988 18.6998 2.93988C19.2798 3.51988 19.2798 4.47988 18.6998 5.05988L11.4398 12.3199C11.1398 12.5999 10.7598 12.7599 10.3798 12.7599Z"
      fill="#891A44"
    />
    <path
      d="M37.6202 12.7599C37.2402 12.7599 36.8602 12.6199 36.5602 12.3199L29.3002 5.05988C28.7202 4.47988 28.7202 3.51988 29.3002 2.93988C29.8802 2.35988 30.8402 2.35988 31.4202 2.93988L38.6802 10.1999C39.2602 10.7799 39.2602 11.7399 38.6802 12.3199C38.4002 12.5999 38.0002 12.7599 37.6202 12.7599Z"
      fill="#891A44"
    />
    <path
      d="M40.42 21.2C40.28 21.2 40.14 21.2 40 21.2H39.54H8C6.6 21.22 5 21.22 3.84 20.06C2.92 19.16 2.5 17.76 2.5 15.7C2.5 10.2 6.52 10.2 8.44 10.2H39.56C41.48 10.2 45.5 10.2 45.5 15.7C45.5 17.78 45.08 19.16 44.16 20.06C43.12 21.1 41.72 21.2 40.42 21.2ZM8.44 18.2H40.02C40.92 18.22 41.76 18.22 42.04 17.94C42.18 17.8 42.48 17.32 42.48 15.7C42.48 13.44 41.92 13.2 39.54 13.2H8.44C6.06 13.2 5.5 13.44 5.5 15.7C5.5 17.32 5.82 17.8 5.94 17.94C6.22 18.2 7.08 18.2 7.96 18.2H8.44Z"
      fill="#891A44"
    />
    <path
      d="M19.52 36.6C18.7 36.6 18.02 35.92 18.02 35.1V28C18.02 27.18 18.7 26.5 19.52 26.5C20.34 26.5 21.02 27.18 21.02 28V35.1C21.02 35.94 20.34 36.6 19.52 36.6Z"
      fill="#1A1C1F"
    />
    <path
      d="M28.7202 36.6C27.9002 36.6 27.2202 35.92 27.2202 35.1V28C27.2202 27.18 27.9002 26.5 28.7202 26.5C29.5402 26.5 30.2202 27.18 30.2202 28V35.1C30.2202 35.94 29.5402 36.6 28.7202 36.6Z"
      fill="#1A1C1F"
    />
    <path
      d="M29.78 45.5H17.72C10.56 45.5 8.96 41.24 8.34 37.54L5.52 20.24C5.38 19.42 5.94 18.66 6.76 18.52C7.58 18.38 8.34 18.94 8.48 19.76L11.3 37.04C11.88 40.58 13.08 42.5 17.72 42.5H29.78C34.92 42.5 35.5 40.7 36.16 37.22L39.52 19.72C39.68 18.9 40.46 18.36 41.28 18.54C42.1 18.7 42.62 19.48 42.46 20.3L39.1 37.8C38.32 41.86 37.02 45.5 29.78 45.5Z"
      fill="#1A1C1F"
    />
  </svg>
);

export default BasketErrorIcon;
